<template>
    <el-dialog
        v-model="dialogVisible"
        width="875"
        :close-on-click-modal="false"
        class="school-list-dialog"
    >
        <template #header>
            <div class="header-box">
                <span class="title-text">结对学校</span>
                <el-input
                    class="search-input"
                    v-model.trim="searchValue"
                    placeholder="输入搜索关键词"
                    clearable
                    :maxlength="100"
                    @keyup.enter="onInputSearch"
                    @clear="clear"
                >
                    <template #suffix>
                        <span class="flex-center" @click="onInputSearch">
                            <i class="iconfont icon-a-sousuoda-zhuye"></i>
                        </span>
                    </template>
                </el-input>
            </div>
        </template>
        <ul class="school-list" v-if="list.length">
            <li v-for="item in list" :key="item.id" @click="goDetail(item.space_url)">
                <div class="img-box">
                    <div
                        v-for="(school, index) in item.schools"
                        :key="item.id + index"
                        class="school-item"
                    >
                        <img :src="school.badge" class="school-badge" />
                        <p class="school-name">{{ school.name }}</p>
                    </div>
                </div>
                <div class="name-box">{{ item.space_name }}</div>
            </li>
        </ul>
        <no-data
            v-else
            :width="240"
            :height="160"
            url="no-data@2x.png"
            info="暂无内容"
            style="margin-top: 90px"
        />
        <template #footer>
            <Pagination
                v-if="pagesParams.total > pagesParams.pageSize"
                :current-page="pagesParams.currentPage"
                :page-size="pagesParams.pageSize"
                :total="pagesParams.total"
                @current-change="search"
                layout="prev, pager , next"
                class="el-pagination--home"
            />
        </template>
    </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { pageJump } from '@/global/location-transfer';
import NoData from '@/components/no-data.vue';
import Pagination from '@/components/pagination/pagination.vue';

defineExpose({ openDialog });

const dialogVisible = ref(false);
const searchValue = ref('');
const finalSearchValue = ref(''); // 按搜索时，输入框的内容才生效
const list = ref([]);
const pagesParams = reactive({
    total: 0,
    pageSize: 6,
    currentPage: 1,
});

function openDialog() {
    list.value = [];
    clear();
    dialogVisible.value = true;
}

function onInputSearch() {
    finalSearchValue.value = searchValue.value;
    search();
}

function search(page) {
    pagesParams.currentPage = page || 1;
    fetchList();
}

function clear() {
    searchValue.value = '';
    finalSearchValue.value = '';
    search();
}

function fetchList() {
    G_transmit('homeSchoolList', {
        name: 'homeSchoolList',
        queries: {
            page_num: pagesParams.currentPage,
            page_size: pagesParams.pageSize,
            search: finalSearchValue.value,
        },
    })
        .then(({ data, status }) => {
            list.value = data?.rows || [];
            pagesParams.total = data?.total_count || 0;
        })
        .catch(err => {
            G_dispatchEvent('toast', { message: err.status.desc, type: 'error' });
        });
}

function goDetail(url) {
    if (!url) return;
    pageJump(url, true);
}
</script>

<style lang="scss">
.school-list-dialog {
    border-radius: 8px;
    .el-dialog__header {
        border-bottom: 1px solid #eeeeee;
        margin-right: 0;
        padding: 10px 24px 10px 20px;
        .el-dialog__title {
            font-size: 16px;
            font-weight: bold;
        }
        .el-dialog__headerbtn {
            top: 1px;
            right: 4px;
            .el-dialog__close {
                color: #222222;
                font-weight: bold;
            }
        }
    }
    .el-dialog__body {
        padding: 20px 20px 0;
        height: 414px;
    }
    .el-dialog__footer {
        padding-top: 0;
        text-align: center;
        --home-main-color: #0089ff;
        --home-main-hover-color: #ecf2ff;
    }
}
</style>

<style lang="scss" scoped>
.header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 37px;
    .title-text {
        font-size: 16px;
        font-weight: bold;
    }
}
.search-input {
    width: 270px;
    height: 36px;
    :deep(.el-input__wrapper) {
        box-shadow: 0 0 0 1px var(--srt-input-border-color) inset;
        padding: 1px 6px 1px 11px;
    }
    :deep(.el-input__suffix) {
        cursor: pointer;
    }
    :deep(.el-input__inner) {
        color: var(--srt-color-black);
    }
    .clear-icon-wrap {
        font-size: 14px;
        margin-right: 12px;
        color: #cccccc;
        display: none;
    }
    &:hover {
        .clear-icon-wrap {
            display: block;
        }
    }
}
:deep(input::-webkit-input-placeholder) {
    /* WebKit browsers */
    color: #cccccc;
}

:deep(input:-moz-placeholder) {
    /* Mozilla Firefox 4 to 18 */
    color: #cccccc;
}

:deep(input::-moz-placeholder) {
    /* Mozilla Firefox 19+ */
    color: #cccccc;
}

:deep(input:-ms-input-placeholder) {
    /* Internet Explorer 10+ */
    color: #cccccc;
}
.icon-a-sousuoda-zhuye {
    font-size: 18px;
    color: #222;
    cursor: pointer;
}
.search-icon-box {
    line-height: 32px;
    text-align: right;
    padding-right: 6px;
}
.img-box {
    width: 100%;
    height: 128px;
    display: inline-block;
    padding: 0 8px;
    background: url('~@/assets/img/home/school-dialog-bg.png') no-repeat 0 0;
    background-size: 100% auto;
    text-align: center;
    .school-item {
        width: 100px;
        display: inline-block;
        vertical-align: top;
        margin: 0 12px;
    }
    .school-badge {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-top: 20px;
    }
    .school-name {
        margin-top: 12px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #222222;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
}
.name-box {
    line-height: 48px;
    padding: 0 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: bold;
    color: #222222;
    border: 1px solid #eeeeee;
    border-top: none;
    border-radius: 0 0 4px 4px;
}
.school-list {
    margin-left: -20px;
    font-size: 0;
    > li {
        display: inline-block;
        width: 265px;
        border-radius: 4px;
        box-sizing: border-box;
        margin: 0 0 20px 20px;
        cursor: pointer;
        &:hover {
            box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);
            .name-box {
                border-color: #fff;
            }
        }
    }
}
</style>
